// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ceFc","col":"styles_col__36WIs"};